import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'ui'
import { FieldAttributesSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'
import { FieldAlignment } from 'database'
import { nativeEnumToArray } from 'bff'
import { useTranslations } from 'i11n'

export const FieldAttributeAlignment: FieldAttributesSignature = ({
  field,
}) => {
  const updateField = usePDFStore((state) => state.updateField)

  const t = useTranslations()

  return (
    <div className='space-y-2'>
      <label className='font-bold text-sm'>Alineación</label>

      <Select
        defaultValue={field.alignment}
        onValueChange={(value: FieldAlignment) =>
          updateField(field.id, {
            alignment: value,
          })
        }
      >
        <SelectTrigger size='sm' className='w-full'>
          <SelectValue placeholder='Selecciona una opción' />
        </SelectTrigger>
        <SelectContent>
          {nativeEnumToArray(FieldAlignment).map((opt, index) => {
            return (
              <SelectItem key={index} value={opt}>
                {t(`text.alignments.${opt}`)}
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    </div>
  )
}
